import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';

import { NavsearchComponent } from './Navsearch.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    MgFormFieldModule,

    // External dependencies
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  declarations: [NavsearchComponent],
  exports: [NavsearchComponent],
})
export class NavsearchModule {}
